export interface ISingleResult {
	type: string;
	permalink: string;
	title: string;
	blurb: string;
	image: string;
	price: string;
}

export interface IResponse {
	success: boolean;
	data?: IResponseData;
}

export interface IResponseData {
	count: string | number;
	query: string;
	results: ISingleResult[];
}

/**
 * Determines if the response is a valid response from the server.
 *
 * @param response The response to check.
 * @returns True if the response is valid, false otherwise.
 */
export function isValidResponse(
	response: IResponse,
): response is Required<IResponse> {
	return !!(response.success && response.data);
}
